import {Component, computed, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute} from '@angular/router';
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatTooltip} from "@angular/material/tooltip";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {MatDialog} from "@angular/material/dialog";
import {AppConfigService} from "../../services/app-config.service";
import {
  CreateAzureResourceForGameComponent
} from "../../components/dialogs/create-azure-resource-for-game/create-azure-resource-for-game.component";
import {GameSettingsComponent} from "../../components/game-settings/game-settings.component";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {ContainerComponent} from "@coreui/angular";
import {MatCard, MatCardContent} from "@angular/material/card";
import {GameService} from "../../services/game.service";

// Route data `isCrossGame` selects different surrounding UI around the shared GameSettingsComponent:
// global scope has nothing to show until a game is picked in the header switcher.
@Component({
  selector: 'app-manage-game',
  standalone: true,
  imports: [
    MatIconButton,
    HasPermissionDirective,
    MatMenuTrigger,
    MatTooltip,
    MatIcon,
    GameSettingsComponent,
    MatMenu,
    MatMenuItem,
    ContainerComponent,
    MatCard,
    MatCardContent
  ],
  templateUrl: './manage-game-page.component.html',
})
export class ManageGamePageComponent {
  private route = inject(ActivatedRoute);
  private gameService: GameService = inject(GameService);
  private matDialog: MatDialog = inject(MatDialog);
  private appConfigService: AppConfigService = inject(AppConfigService);

  protected isCrossGame = this.route.snapshot.data['isCrossGame'] === true;
  protected permissionTypes = PermissionTypes;
  protected allowCreationOfAzureResources = this.appConfigService.allowCreationOfAzureResources();

  // Tracked rather than snapshotted: a field read at construction is correct only for as long as
  // GameScopedRouteReuseStrategy keeps rebuilding this component when the game changes.
  private activeGame$ = toSignal(this.gameService.selectActiveGame$(), {initialValue: undefined});
  protected activeGame = computed<IGameQueryResult | null>(
    () => this.isCrossGame ? null : (this.activeGame$() ?? null));

  onCreateAzureResourcesClick() {
    this.matDialog.open(CreateAzureResourceForGameComponent, {
      width: '80vw'
    });
  }
}
